import React, { useState, useEffect } from 'react';
import { Alert, Button, Modal, Spinner } from '../UI/Index';
import authService from '../../services/authService';

const ShopSelectionModal = ({ isOpen, onShopSelected, onCancel }) => {
  const [shops, setShops] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingShops, setLoadingShops] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchShops = async () => {
      try {
        setLoadingShops(true);
        const availableShops = await authService.getAvailableShops();
        setShops(availableShops);

        const currentUser = authService.getCurrentUser();
        if (currentUser && availableShops.some(shop => shop.shop_id === currentUser.shopId)) {
          setSelectedShopId(currentUser.shopId.toString());
        }
      } catch (err) {
        setError('Error al cargar las tiendas disponibles');
      } finally {
        setLoadingShops(false);
      }
    };

    if (isOpen) {
      fetchShops();
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedShopId) {
      setError('Debe seleccionar una tienda');
      return;
    }

    try {
      setLoading(true);
      setError('');

      const response = await authService.changeShop(parseInt(selectedShopId));

      if (response.success) {
        const updatedUser = authService.getCurrentUser();
        onShopSelected(updatedUser);
      } else {
        setError(response.message || 'Error al cambiar de tienda');
      }
    } catch (err) {
      setError(err.message || 'Error al cambiar de tienda');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Seleccionar Tienda"
      size="md"
    >
      {error && <Alert type="error" message={error} onClose={() => setError('')} />}

      <div className="mt-4">
        <p className="mb-4 text-sm text-gray-600">
          Selecciona la tienda en la que quieres hacer el inventario:
        </p>

        {loadingShops ? (
          <div className="flex items-center justify-center py-8">
            <Spinner size="md" />
            <span className="ml-2 text-sm text-gray-500">Cargando tiendas...</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="shopSelect" className="block text-sm font-medium text-gray-700 mb-2">
                Tienda *
              </label>
              <select
                id="shopSelect"
                value={selectedShopId}
                onChange={(e) => setSelectedShopId(e.target.value)}
                required
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              >
                <option value="">Selecciona una tienda</option>
                {shops.map((shop) => (
                  <option key={shop.shop_id} value={shop.shop_id}>
                    {shop.shop_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-end space-x-3">
              <Button type="secondary" onClick={onCancel} disabled={loading}>
                Cancelar
              </Button>
              <Button type="primary" buttonType="submit" disabled={loading || !selectedShopId}>
                {loading ? (
                  <>
                    <Spinner size="sm" className="mr-2" />
                    Seleccionando...
                  </>
                ) : (
                  'Continuar'
                )}
              </Button>
            </div>
          </form>
        )}
      </div>
    </Modal>
  );
};

export default ShopSelectionModal;